function xhrSendPOST(api_link, data, isJSON) {
  let xhr = new XMLHttpRequest();
  xhr.open('POST', api_link, false);
  if (isJSON) {
    xhr.setRequestHeader("Accept", "application/json");
    xhr.setRequestHeader("Content-Type", "application/json");
  }
  try {
    xhr.send(data);
  }
  catch (exception) {
    console.log(exception);
    return false;
  }

  if (xhr.status >= 200 && xhr.status < 400) {
    if (xhr.responseText.length == 0) {
      return 'empty';
    }
    return xhr.responseText;
  } else {
    return false;
  }
}

window.addEventListener(`DOMContentLoaded`, () => {
  // submit form
  document.addEventListener('fetchit:after', function(e) {
    event.preventDefault()
    const { form, response } = e.detail
    let helpline = '';
    let yacline = '';
    const formEN = document.querySelector(`.form-en`);
    const spinner = document.querySelector('.spinner-box');
    if (formEN) {
      helpline = 'Confirm your consent to the processing of personal data.';
      yacline = 'Verification failed, please reload page';
    } else {
      helpline = 'Подтвердите выбор, чтобы продолжить';
      yacline = 'Ошибка валидации. Попробуйте обновить страницу';
    }

    if (response.success) {
      if (form.classList.contains('js-ask_question')) {
        if (dataLayer) {
          dataLayer.push( { 'event' : 'form-askquestion' } )
        }
      }
      if (form.classList.contains('js-ask_consultation')) {
        if (dataLayer) {
          dataLayer.push( { 'event' : 'request-consultation' } )
        }
      }

      if (form.classList.contains('form-zpif')) {
        console.log('reachGoal zpifsubmit');
        ym(10543570, 'reachGoal', 'zpifsubmit')
      }
      if(form.classList.contains('form__family')) {
        ym(10543570, 'reachGoal', 'familyfundsubmit')
      }

      // если сообщение об успешной отправки находится внутри формы
      const lastElem = form.querySelector('.js-success-content-wrapper')
      const submitBtn = form.querySelector('.js-submit-btn')
      const inputs = form.querySelectorAll('.input__input')
      const filesList = form.querySelector('.js-files-list')
      const deleteFiles = form.querySelector('.js-delete-files')
      if (lastElem) {
        if(lastElem.classList.contains('form__success-content-wrapper')) {
          lastElem.classList.add('active')
          if (submitBtn) {
            submitBtn.style.display = 'none'
          }
          if (inputs) {
            inputs.forEach( inpt => {
              inpt.setAttribute('disabled', true)
            })
          }
          if (filesList) {
            filesList.setAttribute('disabled', true)
          }
          if (deleteFiles) {
            deleteFiles.setAttribute('disabled', true)
          }
        }
      }
      let nextElem = form.nextElementSibling
      if (form.classList.contains('js-feedback_main')) {
        nextElem = form.querySelector('.js-success-content-wrapper')
      }
      if(nextElem) {
        if(nextElem.classList.contains('form__success-content-wrapper')) {
          nextElem.classList.add('active')
          // nextElem.closest('.modal__container').classList.add('success_show')

          if(!nextElem.classList.contains('not-modal')) {
            let modalContainer = form.closest('.modal__container')
            modalContainer.querySelector('.js-user-mail').textContent = response.data.mail
            modalContainer.querySelector('.modal__title').style.visibility = 'hidden'
            modalContainer.querySelector('.modal__desc').style.display = 'none'
            modalContainer.querySelectorAll('br').forEach(br => br.remove())
          }

          if (form.classList.contains('js-feedback_main')) {
            setTimeout(function(){
              form.querySelector('.js-switch-window').click()
            }, 6000)
          } else {
            form.style.display = 'none'
          }

          if(spinner) {
            spinner.classList.remove('active')
          }
        }

      } else {
        // редиректы для ЛК Аналитики
        if(form.dataset.urlRedirect === 'analytic') {
          if (window.location.href.includes('analytic')) {
            document.location.reload()
          }
          else {
            window.location.href = form.dataset.urlRedirect
          }
        }
      }

      if (form.dataset.sendLead) {
        if (document.querySelector('.js-form-success')) {
          document.querySelector('.js-form-success').scrollIntoView()
        }
      }

      if (form.dataset.sendCase) {
        //Объявляем ссылку на внутренний API
        let api_case_create

        if (window.location.host === 'www.dohod.ru') {
          api_case_create = 'https://api.dohod.ru/dohod/api/public/crm/case/'
        } else {
          api_case_create = 'https://test-api.dohod-am.ru/dohod/api/public/crm/case/'
        }
        //проверяем размер файла, не больше 5мб
        const fileInputService = document.getElementById('fileservice')
        //Неизменяемые ID для обработки данных запроса в CRM
        const ClientTypeId = '335735ff-3355-4002-a4b2-505b7e16dd74'; //Клиент / Представитель
        const CaseCategoryId = '1c0bc159-150a-e111-a31b-00155d04c01d'; //Тип обращения - запрос на обслуживание
        //Берем данные с формы для формирования запроса
        const formData = new FormData(form)
        //Имя в обращении
        let $name = form.querySelector('[name="name"]')?.value
        let $surname = form.querySelector('[name="surname"]')?.value
        let $midname = form.querySelector('[name="midname"]')?.value
        let $service = form.querySelector('[name="service"]')?.value
        let $mail = form.querySelector('[name="mail"]')?.value
        let $tel = form.querySelector('[name="tel"]')?.value.replace(/[()\-\s]/g, '')
        let $contract = form.querySelector('[name="contract"]')?.value
        let $orgname = form.querySelector('[name="orgname"]')?.value
        let $comment = form.querySelector('[name="comment"]')?.value
        let nameField = $surname + ' ' + $name + ' ' + $midname
        let serviceField = $service ? $service : 'Вопросы по сайту'
        //Запрос на создание клиента
        let data_send = {
          "name": nameField,
          "firstName": $name,
          "lastName": $surname,
          "middleName": $midname,
          "email": $mail,
          "mobilePhone": $tel,
          "accountNumber": $contract,
          "legalEntityName": $orgname,
          "comment": $comment,
          "caseSubject": serviceField,
          "caseSymptoms": $comment,
          "caseCategoryId": CaseCategoryId,
          "typeId": ClientTypeId
        }
        data_send = JSON.stringify(data_send)
        //Берем созданное обращение для прикрепления файла внутрь
        const sendLead = () => {
          let caseId = xhrSendPOST(api_case_create, data_send, true)
          if (!caseId || (caseId === 'empty')) {
            form.parentElement.querySelector('.form-success__title').innerHTML = 'Ошибка!'
            if(form.parentElement.querySelector('.form-success-kids__title')) {
              form.parentElement.querySelector('.form-success-kids__title').innerHTML = 'Ошибка отправки сообщения. Попробуйте еще раз.'
              form.parentElement.querySelector('.form-success-kids__text img').setAttribute('src', '/assets/src/assets/img/kids/form-error.png')
            }
            if(form.parentElement.querySelector('.form-success__text p')) {
              form.parentElement.querySelector('.form-success__text p').innerHTML = 'Похоже, с нашей стороны произошла ошибка при попытке отправить обращение,  мы уже работаем над её исправлением.'
            }
            return false
          }
        }
        // caseId = JSON.parse(caseId);
        let fileData = []
        if (fileInputService) {
          fileData = fileInputService.files
        } // Должно выводить список выбранных файлов
        let file_attach_response;
        // const fileData = formData.get("file");
        if (fileData && (fileData.length > 0)) {
          let formDataFile = new FormData();
          formDataFile.append('caseRequest', data_send)

          fileData.forEach((file) => {
            // let formDataFile = new FormData();
            if (file.size > 0) {
              formDataFile.append("files", file);
              // file_attach_response = xhrSendPOST(api_case_create + caseId + '/file', formDataFile, false);
            } else {
              file_attach_response = 'no File uploaded';
            }
          })

          if (formDataFile.get('files')) {
            file_attach_response = xhrSendPOST(api_case_create + 'file', formDataFile, false)
          } else {
            sendLead()
          }

        } else {
          sendLead()
          file_attach_response = 'no File uploaded';
        }
        //Вывод окна успешной отправки
        if (!file_attach_response) {
          form.parentElement.querySelector('.form-success__title').innerHTML = 'Ошибка!'
          form.parentElement.querySelector('.form-success__text p').innerHTML = 'Похоже, с нашей стороны произошла ошибка при попытке отправить обращение,  мы уже работаем над её исправлением.'
          return false
        }
      }

    } else {
      const errors = form.querySelectorAll('.error-template')
        if(errors.length) {
          let obj = response.data

          Object.keys(obj).forEach(function(key) {
            let element = form.querySelector('[data-error="'+key+'"]')
            if(element) {
              element.innerHTML = obj[key]
            }
            if(key === 'smart-token') {
              element.innerHTML = 'Ошибка валидации. Попробуйте обновить страницу.'
            }
          })

          form.querySelectorAll('.error-template').forEach((element) => {
            if (element.classList.contains('error_smart-token')) {
              element.textContent = yacline
            }

            if (element.querySelector('.error')) {
              let text = ''
              const parentInput = element.closest('.input')

              if (parentInput && parentInput.querySelector('.input__input')?.getAttribute('type') === 'checkbox') {
                text += helpline
              } else {
                element.querySelectorAll('.error').forEach((element1) => {
                  text = text ? text + '' : element1.textContent
                })
              }

              if (parentInput) {
                parentInput.classList.add('invalid')
                parentInput.setAttribute('data-invalid', text)
              }
            } else {
              const parentInput = element.closest('.input')
              if (parentInput) {
                parentInput.classList.remove('invalid')
                parentInput.setAttribute('data-invalid', '')
              }
            }
          })

          if(spinner) {
            spinner.classList.remove('active')
          }
        }
    }
  })
})
